module.exports = __webpack_public_path__ + "media/images/quotation-mark-b6f914037a767e86ae96bfa68054fc82.svg";